import React from 'react';
import { Modal } from 'antd';
import ScopedSummarySettings from './ScopedSummarySettings';

const SummarySettingsModal = ({ visible, onCancel, projectId, projectName }) => {
    return (
        <Modal
            title={`Summary Settings - ${projectName}`}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="70%"
            style={{ top: 20 }}
            bodyStyle={{ 
                maxHeight: 'calc(100vh - 200px)', 
                overflowY: 'auto',
                padding: '24px'
            }}
            destroyOnClose
        >
            <ScopedSummarySettings 
                projectId={projectId}
                projectName={projectName}
                scopeId={projectId}
                onClose={onCancel}
            />
        </Modal>
    );
};

export default SummarySettingsModal;

